module.exports = __webpack_public_path__ + "img/effect.b489db19.png";